// Effect Bus - Routes effects to appropriate handlers
// No state management, just routing and error handling

import { DialogueEffect } from './types';

export interface EffectHandler {
  canHandle(effect: DialogueEffect): boolean;
  handle(effect: DialogueEffect): Promise<void>;
}

export class EffectBus {
  private handlers: EffectHandler[] = [];
  private manual: boolean = false;
  private queue: DialogueEffect[] = [];

  constructor(handlers: EffectHandler[], options?: { manual?: boolean }) {
    this.handlers = handlers;
    this.manual = !!options?.manual;
  }

  async runEffects(effects: DialogueEffect[]): Promise<void> {
    if (this.manual) {
      this.queue.push(...effects);
      return;
    }
    for (const effect of effects) {
      await this.executeEffect(effect);
    }
  }

  getPendingEffects(): DialogueEffect[] {
    return [...this.queue];
  }

  async stepNext(): Promise<void> {
    const next = this.queue.shift();
    if (!next) return;
    await this.executeEffect(next);
  }

  async drainAll(): Promise<void> {
    while (this.queue.length > 0) {
      const next = this.queue.shift();
      if (next) {
        await this.executeEffect(next);
      }
    }
  }

  private async executeEffect(effect: DialogueEffect): Promise<void> {
    try {
      console.log('🔷 [EffectBus] Executing effect:', effect.type);
      const handler = this.handlers.find(h => h.canHandle(effect));
      
      if (!handler) {
        console.warn('🔷 [EffectBus] No handler found for effect:', effect.type);
        return;
      }

      console.log('🔷 [EffectBus] Found handler, calling handle() for:', effect.type);
      await handler.handle(effect);
      console.log('🔷 [EffectBus] Handler completed for:', effect.type);
    } catch (error) {
      console.error('🔷 [EffectBus] Error executing effect:', effect.type, error);
      // Don't throw - let other effects continue
    }
  }
}
